<div class="fileManagerShell" [ngClass]="isDownloading ? 'hasLoader' : ''">
  <ng-container>
    <div [hidden]="isDownloading" style="height: 100%">
      <p class="fileManagerShell-selectBranchLbl">Search By Job Number (or) Location Name (or) Trailer ID</p>
      <div style="float: right; margin: 0 10px;">
                <span style="font-weight: bold;">Download:</span>
                <a  [href]="GuidedownloadUrl" style="text-decoration: underline;"  target="_blank">CFG File Guide</a>
      </div>
      <kendo-combobox
        [virtual]="true"
        [filterable]="true"
        [loading]="autoCompleteLoading"
        [textField]="'formattedName'"
        [valueField]="isAzureFiles ? 'formattedName' : 'formattedDistNum'"
        placeholder="Please enter atleast 3 characters"
        [(value)]="selectedFolderSuggestion"
        (selectionChange)="valueSelected($event)"
        [disabled]="gridDataLoading"
        class="fileManagerShell-selectBranch"
        (filterChange)="handleValue($event)"
        [data]="folderSuggestions$ | async"
      >
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <div class="grid-folderCol">
            <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="!dataItem.getFromDb">folder</mat-icon>
            <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="dataItem.getFromDb">place</mat-icon>
            {{dataItem.formattedName }}
          </div>
        </ng-template>
      </kendo-combobox>
      <div class="fileManagerShell-container">
        <kendo-breadcrumb [items]="items" class="fileManagerShell-breadCrumb">
          <ng-template kendoBreadCrumbItemTemplate let-item let-index="index">
            <div class="item" role="button" *ngIf="index === 0" (click)="onItemClick(item, index)">
            <span role="link" class="k-cursor-pointer k-flex-none k-breadcrumb-root-link k-breadcrumb-icontext-link">
              <span class="k-i-home k-icon ng-star-inserted"></span>
              <span style="text-decoration: underline">{{item.text}}</span>
            </span>
            </div>
            <kendo-dropdownlist
              [disabled]="gridDataLoading"
              *ngIf="index > 0"
              [popupSettings]="{width: 'auto'}"
              [data]="item.dropdownData"
              [virtual]="true"
              [(value)]="item.selectedValue"
              [kendoDropDownFilter]="filterSettings"
              valueField="name"
              textField="name">
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                <div (click)="onItemClick(dataItem, index, item)">
                   {{ dataItem.name }}
                </div>
              </ng-template>
            </kendo-dropdownlist>
          </ng-template>
        </kendo-breadcrumb>
        <kendo-grid
          [ngClass]="{
      'bounceIn': filterApplied,
      'slideFromRightAnim': folderClicked
    }"
          [kendoGridBinding]="gridData"
          [loading]="gridDataLoading"
          [resizable]="true"
          [filterable]="'menu'"
          [style.height.%]="85"
          class="fileManagerShell-grid"
          [skip]="state.skip"
          [filter]="state.filter"
          [pageSize]="state.take"
          [sortable]="true"
          (dataStateChange)="dataStateChange($event)"
          [pageable]="{
          buttonCount: buttonCount,
          info: info,
          type: type,
          pageSizes: pageSizes,
          previousNext: previousNext
        }"
        >

          <kendo-grid-column media="(max-width: 450px)" title="Files">
            <ng-template kendoGridCellTemplate let-dataItem>
              <!-- template for mobile -->
                <div class="row" style="margin-bottom: 10px">
                  <div class="col-6">
                    <div style="font-weight: bold;color: #595959">Job/File Name</div>
                    <div class="grid-folderCol" style="white-space: normal;text-overflow: ellipsis;overflow: hidden" (click)="navigate(dataItem)">
                      <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="!dataItem.isFile">folder</mat-icon>
                      <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="dataItem.isFile">insert_drive_file
                      </mat-icon>  {{dataItem.name || 'N/A'}}
                    </div>
                  </div>
                  <div class="col-6">
                    <div style="font-weight: bold;color: #595959">Last Modified</div>
                    <div>{{ (dataItem.lastModified | date) || 'N/A'}}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div style="font-weight: bold;color: #595959">Size</div>
                    <div>{{dataItem.size ? dataItem.size : 'N/A'}}</div>
                  </div>
                  <div class="col-6">
                    <div *ngIf="dataItem.isFile" style="font-weight: bold;color: #595959">Action</div>
                    <div class="grid-folderCol" *ngIf="dataItem.isFile">
              <span matTooltip="Copy Path"
                    matTooltipPosition="left">
                <mat-icon color="primary" class="copyIcon" [cdkCopyToClipboard]="copyToClipBoard(dataItem)" (cdkCopyToClipboardCopied)="copiedEvent()">file_copy</mat-icon>
              </span>
                      <span matTooltip="Download"
                            matTooltipPosition="right">
                 <mat-icon color="primary" class="downloadIcon" (click)="downloadFile(dataItem, true)">download</mat-icon>
              </span>
                    </div>
                  </div>
                </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="name" media="(min-width: 680px)" title="Job/File Name">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="grid-folderCol" (click)="navigate(dataItem)">
                <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="!dataItem.isFile">folder</mat-icon>
                <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="dataItem.isFile">insert_drive_file
                </mat-icon>  {{dataItem.name || 'N/A'}}
              </div>
            </ng-template>
            <ng-template kendoGridFilterMenuTemplate
                         let-filter let-column="column" let-filterService="filterService">
              <kendo-grid-string-filter-menu
                [column]="column" [filter]="filter" [filterService]="filterService"
                [extra]="false"
              >
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-menu>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="lastModified"  media="(min-width: 680px)"title="Last Modified" [filterable]="false" *ngIf="!selectedFolderSuggestion?.getFromDb || items.length > 0">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{dataItem.lastModified ? (dataItem.lastModified | date) : 'N/A'}}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="size" media="(min-width: 680px)" title="Size" [filterable]="false" *ngIf="!selectedFolderSuggestion?.getFromDb || items.length > 0">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{dataItem.size ? dataItem.size : 'N/A'}}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="isFile" media="(min-width: 680px)" title="Action" [filterable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="grid-folderCol" *ngIf="dataItem.isFile">
              <span matTooltip="Copy Path"
                    matTooltipPosition="left">
                <mat-icon color="primary" class="copyIcon" [cdkCopyToClipboard]="copyToClipBoard(dataItem)" (cdkCopyToClipboardCopied)="copiedEvent()">file_copy</mat-icon>
              </span>
                <span matTooltip="Download"
                      matTooltipPosition="right">
                 <mat-icon color="primary" class="downloadIcon" (click)="downloadFile(dataItem)">download</mat-icon>
              </span>
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </ng-container>
  <app-tke-loader [isLoading]="isDownloading"></app-tke-loader>
</div>

